import {
  GradesDTO,
} from 'src/stores/backend/GradesStore/types';
import {
  LanguagesKey,
} from 'src/translations/types';
import {
  BaseFormViewModel,
} from '../types';

export class Grade extends BaseFormViewModel<GradesDTO> {
  id?: number;

  englishName: string;

  arabicName: string;

  constructor(data: GradesDTO) {
    super();
    this.id = data.id;
    this.englishName = data.translations?.filter((item) => item.languageCode === LanguagesKey.EN)[0].title;
    this.arabicName = data.translations?.filter((item) => item.languageCode === LanguagesKey.AR)[0].title;
  }

  toDTO(): GradesDTO {
    return { } as GradesDTO;
  }
}
